import { create } from 'zustand';

const initialState = {
  cryptoOnboardingComplete: null,
  onboardingStage: null,
  hasStripeAccount: null,
  continueFiatOnboarding: false,
  stripeOnboardingStatus: null,
};

export const useOnboardingStore = create((set) => ({
  ...initialState,
  
  setCryptoOnboardingComplete: (cryptoOnboardingComplete) => set({ cryptoOnboardingComplete }),
  setOnboardingStage: (onboardingStage) => set({ onboardingStage }),
  setHasStripeAccount: (hasStripeAccount) => set({ hasStripeAccount }),
  setContinueFiatOnboarding: (continueFiatOnboarding) => set({ continueFiatOnboarding }),
  setStripeOnboardingStatus: (stripeOnboardingStatus) => set({ stripeOnboardingStatus }),
  resetOnboarding: () => set(initialState)
}));

export const useCryptoOnboardingComplete = () => useOnboardingStore(state => state.cryptoOnboardingComplete);
export const useOnboardingStage = () => useOnboardingStore(state => state.onboardingStage);
export const useHasStripeAccount = () => useOnboardingStore(state => state.hasStripeAccount);
export const useContinueFiatOnboarding = () => useOnboardingStore(state => state.continueFiatOnboarding);
export const useStripeOnboardingStatus = () => useOnboardingStore(state => state.stripeOnboardingStatus);

export const useSetCryptoOnboardingComplete = () => useOnboardingStore(state => state.setCryptoOnboardingComplete);
export const useSetOnboardingStage = () => useOnboardingStore(state => state.setOnboardingStage);
export const useSetHasStripeAccount = () => useOnboardingStore(state => state.setHasStripeAccount);
export const useSetContinueFiatOnboarding = () => useOnboardingStore(state => state.setContinueFiatOnboarding);
export const useSetStripeOnboardingStatus = () => useOnboardingStore(state => state.setStripeOnboardingStatus);
export const useResetOnboarding = () => useOnboardingStore(state => state.resetOnboarding);